// extracted by mini-css-extract-plugin
export default {"content":"FieldSelectionModal-module__content--xxNdB"};